/**
 * @generated SignedSource<<b282675b7f1d21dbbe8e782ee09a6f9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedRestrictedMaterials_viewer$data = {
  readonly transactionWarnings?: {
    readonly hasRestrictedMaterials: boolean | null;
  } | null;
  readonly " $fragmentType": "PdpSharedRestrictedMaterials_viewer";
};
export type PdpSharedRestrictedMaterials_viewer$key = {
  readonly " $data"?: PdpSharedRestrictedMaterials_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedRestrictedMaterials_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedRestrictedMaterials_viewer",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "country",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            }
          ],
          "concreteType": "TransactionWarningQueryType",
          "kind": "LinkedField",
          "name": "transactionWarnings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasRestrictedMaterials",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "386f5a3514dde9834e124fc4bb18b294";

export default node;
